import module from 'nominas/sumario/module.js'
import * as moment from 'moment'

const schema = {
  fecha: 'date',
  fecha_pago: 'date',
  fecha_inicial: 'date',
  fecha_final: 'date',
  suministro: 'number',
  avance: 'number',
  id_moneda: 'number',
  id_tipo_nomina: 'number',
  sa: {
    id: 'number',
    comision: 'number',
    otros: 'number',
    subtotal: 'number',
    iva: 'number',
    total: 'number',
  },
  op: {
    id: 'number',
    comision: 'number',
    otros: 'number',
    subtotal: 'number',
    iva: 'number',
    total: 'number',
  },
  revision: {
    maquila: 'boolean',
    revision: 'boolean',
    cierre: 'boolean',
    estado_cuenta: 'boolean',
    timbrado: 'boolean',
    imprimir_cfdi: 'boolean',
    envio_cfdi: 'boolean',
    factura: 'boolean',
    pagado: 'boolean',
    dispersado: 'boolean',
    visible: 'boolean',
  },
}

export class NominasSumario {
  constructor ($http, $q) {
    this.$http = $http
    this.$q = $q
  }

  get (config) {
    return this.$http.get('/kendu/nominas/sumario', {
      params: {
        id_proyectos: config.idProyectos.join(','),
        fecha_inicial: moment(config.fechaInicial).format('YYYY-MM-DD'),
        fecha_final: moment(config.fechaFinal).format('YYYY-MM-DD'),
        id_moneda: config.idMoneda,
        id_tipo_nomina: config.idTipoNomina,
        importe: config.importe,
        estatus: config.estatus,
      },
      schema,
    })
  }

  review (idProyecto, idNomina, data) {
    return this.$http.put('/api/nominas/sumario/review', data, {
      params: {ID_Empresa: idProyecto, ID_Nomina: idNomina},
      schema: {status: 'boolean'},
    })
  }
}

module.service('NominasSumario', NominasSumario)



// WEBPACK FOOTER //
// ./src/nominas/sumario/services/NominasSumario.js